export class Constants {
  public static incentiveRequiredLocation = 'United States';
  public static incentiveSupportStartDate = new Date('09/04/2020');

  public static poeDocumentType = [
    { type: 'Invoice' },
    { type: 'Findings document' },
    { type: 'RFP Award Letter' },
    { type: 'RFP Description' },
    { type: 'Statement of Work' }
  ];
}
